export default {"src":"/_next/static/media/arrow-icon-active.8a68a925.svg","height":17,"width":15,"blurWidth":0,"blurHeight":0};